(function() {
    'use strict';
    
    // Hero Website Slider
    const HeroWebsite = {
        init() {
            const heroSlider = document.querySelector('.hero-website--slider');
            if (!heroSlider) return;
            
            const slider = heroSlider.querySelector('.hero-website__slider');
            const slides = heroSlider.querySelectorAll('.hero-website__slide');
            const prevBtn = heroSlider.querySelector('.hero-website__control--prev');
            const nextBtn = heroSlider.querySelector('.hero-website__control--next');
            const indicators = heroSlider.querySelectorAll('.hero-website__indicator');
            
            let currentSlide = 0;
            const totalSlides = slides.length;
            let autoplayInterval;
            
            const goToSlide = (index) => {
                if (index < 0) index = totalSlides - 1;
                if (index >= totalSlides) index = 0;
                
                currentSlide = index;
                slider.style.transform = `translateX(-${currentSlide * 100}%)`;
                
                indicators.forEach((indicator, i) => {
                    indicator.classList.toggle('hero-website__indicator--active', i === currentSlide);
                });
            };
            
            const nextSlide = () => goToSlide(currentSlide + 1);
            const prevSlide = () => goToSlide(currentSlide - 1);
            
            // Event listeners
            if (prevBtn) {
                prevBtn.addEventListener('click', prevSlide);
            }
            
            if (nextBtn) {
                nextBtn.addEventListener('click', nextSlide);
            }
            
            indicators.forEach((indicator) => {
                indicator.addEventListener('click', () => {
                    goToSlide(parseInt(indicator.dataset.slide));
                });
            });
            
            // Keyboard navigation (only when hero is focused)
            let isHeroFocused = false;
            
            heroSlider.addEventListener('mouseenter', () => {
                isHeroFocused = true;
            });
            
            heroSlider.addEventListener('mouseleave', () => {
                isHeroFocused = false;
            });
            
            document.addEventListener('keydown', (e) => {
                if (!isHeroFocused) return;
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    prevSlide();
                }
                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    nextSlide();
                }
            });
            
            // Touch/swipe support
            let touchStartX = 0;
            let touchEndX = 0;
            
            slider.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });
            
            slider.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                const diff = touchEndX - touchStartX;
                
                if (diff < -50) nextSlide();
                if (diff > 50) prevSlide();
            });
        }
    };
    
    // FAQ Website Accordion
    const FAQWebsite = {
        init() {
            const faqItems = document.querySelectorAll('.faq-website__item');
            if (!faqItems.length) return;
            
            faqItems.forEach((item) => {
                const question = item.querySelector('.faq-website__question');
                const answer = item.querySelector('.faq-website__answer');
                
                if (!question || !answer) return;
                
                question.addEventListener('click', () => {
                    const isActive = item.classList.contains('faq-website__item--active');
                    
                    // Close all items
                    faqItems.forEach((otherItem) => {
                        otherItem.classList.remove('faq-website__item--active');
                        const otherAnswer = otherItem.querySelector('.faq-website__answer');
                        if (otherAnswer) otherAnswer.style.maxHeight = null;
                    });
                    
                    // Toggle current item
                    if (!isActive) {
                        item.classList.add('faq-website__item--active');
                        answer.style.maxHeight = answer.scrollHeight + 'px';
                    }
                });
            });
        }
    };
    
    // Contact Form Website
    const ContactFormWebsite = {
        stations: [],

        init() {
            const contactForm = document.getElementById('contactForm');
            if (!contactForm) return;

            // Cargar estaciones
            this.loadStations();

            // Escuchar cambios en el plan para actualizar regiones
            const planSelect = document.getElementById('plan_type');
            if (planSelect) {
                planSelect.addEventListener('change', () => {
                    this.updateRegionsByPlan(planSelect.value);
                });
            }

            contactForm.addEventListener('submit', async (e) => {
                e.preventDefault();

                // Validar campos requeridos
                const name = contactForm.querySelector('[name="name"]').value.trim();
                const lastname = contactForm.querySelector('[name="lastname"]').value.trim();
                const email = contactForm.querySelector('[name="email"]').value.trim();
                const planType = contactForm.querySelector('[name="plan_type"]').value;
                const region = contactForm.querySelector('[name="region"]').value;

                if (!name || !lastname || !email || !planType || !region) {
                    return;
                }

                // Preparar datos para enviar
                const formData = new FormData(contactForm);
                const data = {
                    name: formData.get('name'),
                    surname: formData.get('lastname'), // Mapear lastname -> surname
                    email: formData.get('email'),
                    phone: formData.get('phone') || '',
                    plan_type: formData.get('plan_type') || '',
                    city: formData.get('region') || '', // Mapear region -> city
                    message: formData.get('message') || ''
                };

                // Deshabilitar botón mientras se envía
                const submitButton = contactForm.querySelector('button[type="submit"]');
                submitButton.disabled = true;
                submitButton.textContent = 'ENVIANDO...';

                // Enviar al backend
                try {
                    const response = await fetch('/api/kinto/forms/website_contact/', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').content
                        },
                        body: JSON.stringify(data)
                    });

                    if (response.ok) {
                        // Mostrar mensaje de éxito
                        const successMessage = document.createElement('div');
                        successMessage.className = 'form-success-message';
                        successMessage.textContent = '¡Gracias! Tu solicitud ha sido enviada correctamente. Un asesor KINTO te contactará pronto.';
                        successMessage.style.cssText = 'background: #00708d; color: white; padding: 24px; border-radius: 5px; margin-top: 20px; text-align: center; font-size: 16px;';
                        contactForm.appendChild(successMessage);
                        
                        // Resetear formulario
                        contactForm.reset();
                        
                        // Ocultar mensaje después de 5 segundos
                        setTimeout(() => {
                            successMessage.remove();
                        }, 5000);
                    } else {
                        const errorData = await response.json();
                        console.error('Error al enviar:', errorData);
                        alert('Hubo un error al enviar el formulario. Por favor intenta nuevamente.');
                    }
                } catch (error) {
                    console.error('Error:', error);
                    alert('Hubo un error al enviar el formulario. Por favor intenta nuevamente.');
                } finally {
                    // Rehabilitar botón
                    submitButton.disabled = false;
                    submitButton.textContent = 'SOLICITA INFORMACIÓN';
                }
            });
        },

        async loadStations() {
            try {
                const response = await fetch('/api/kinto/stations');
                if (response.ok) {
                    this.stations = await response.json();
                }
            } catch (error) {
                console.error('Error al cargar estaciones:', error);
            }
        },

        updateRegionsByPlan(planType) {
            const regionSelect = document.getElementById('region');
            if (!regionSelect) return;

            // Limpiar opciones actuales (excepto la primera)
            regionSelect.innerHTML = '<option value="" disabled selected>Barrio o región</option>';

            if (!planType) return;

            // Mapear el valor del plan al campo del modelo
            const planFieldMap = {
                'share': 'kinto_share',
                'onep': 'kinto_one_personal',
                'oneb': 'kinto_one_business'
            };

            const planField = planFieldMap[planType];
            if (!planField) return;

            // Filtrar estaciones por plan
            const filteredStations = this.stations.filter(station => station[planField]);

            // Obtener regiones únicas de las estaciones filtradas
            const regions = [...new Set(filteredStations
                .map(station => station.city?.name)
                .filter(city => city)
            )].sort();

            // Agregar opciones al select
            regions.forEach(region => {
                const option = document.createElement('option');
                option.value = region;
                option.textContent = region;
                regionSelect.appendChild(option);
            });

            // Resetear el valor seleccionado
            regionSelect.value = '';
        }
    };

    // KINTO Stations Dropdown
    const StationsDropdown = {
        init() {
            const dropdownButtons = document.querySelectorAll('.zigzag-sticky-image-website__dropdown-button');
            
            dropdownButtons.forEach(button => {
                const dropdown = button.closest('.zigzag-sticky-image-website__dropdown');
                if (dropdown) {
                    this.setupDropdown(dropdown);
                }
            });
        },

        setupDropdown(dropdown) {
            const button = dropdown.querySelector('.zigzag-sticky-image-website__dropdown-button');
            const menu = dropdown.querySelector('.zigzag-sticky-image-website__dropdown-menu');
            const wrapper = dropdown.closest('.zigzag-sticky-image-website__dropdown-wrapper');
            const resultsContainer = wrapper.querySelector('.zigzag-sticky-image-website__stations-results');
            
            let citiesData = [];

            const openDropdown = () => {
                button.setAttribute('aria-expanded', 'true');
                menu.style.display = 'block';
                
                if (citiesData.length === 0) {
                    loadCities();
                }
            };

            const closeDropdown = () => {
                button.setAttribute('aria-expanded', 'false');
                menu.style.display = 'none';
            };

            const loadCities = () => {
                const loadingDiv = menu.querySelector('.zigzag-sticky-image-website__dropdown-loading');
                loadingDiv.textContent = 'Cargando ciudades...';
                
                fetch('/api/kinto/cities_with_stations/')
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Error al cargar las ciudades');
                        }
                        return response.json();
                    })
                    .then(data => {
                        citiesData = data;
                        renderCities(data);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        loadingDiv.textContent = 'Error al cargar las ciudades. Por favor, intenta nuevamente.';
                    });
            };

            const renderCities = (cities) => {
                if (cities.length === 0) {
                    menu.innerHTML = '<div class="zigzag-sticky-image-website__dropdown-loading">No hay ciudades disponibles</div>';
                    return;
                }

                menu.innerHTML = '';
                
                cities.forEach(city => {
                    const item = document.createElement('div');
                    item.className = 'zigzag-sticky-image-website__dropdown-item';
                    item.textContent = city.name;
                    item.setAttribute('data-city-id', city.id);
                    item.setAttribute('role', 'option');
                    item.setAttribute('tabindex', '0');
                    
                    item.addEventListener('click', () => selectCity(city));
                    item.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            selectCity(city);
                        }
                    });
                    
                    menu.appendChild(item);
                });
            };

            const selectCity = (city) => {
                const buttonText = button.querySelector('.zigzag-sticky-image-website__dropdown-button-text');
                buttonText.textContent = city.name;
                closeDropdown();
                displayStations(city);
            };

            const displayStations = (city) => {
                const stationsList = resultsContainer.querySelector('.zigzag-sticky-image-website__stations-list');
                
                stationsList.innerHTML = '';
                
                if (!city.stations || city.stations.length === 0) {
                    stationsList.innerHTML = '<p style="color: #002732;">No hay estaciones disponibles en esta ciudad.</p>';
                    resultsContainer.style.display = 'block';
                    return;
                }
                
                city.stations.forEach(station => {
                    const card = createStationCard(station);
                    stationsList.appendChild(card);
                });
                
                resultsContainer.style.display = 'block';
                
                setTimeout(() => {
                    resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 100);
            };

            const createStationCard = (station) => {
                const card = document.createElement('div');
                card.className = 'zigzag-sticky-image-website__station-card';
                
                // Content wrapper (name + info)
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'zigzag-sticky-image-website__station-content';
                
                const nameContainer = document.createElement('div');
                nameContainer.className = 'zigzag-sticky-image-website__station-name';
                nameContainer.innerHTML = `
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3013_47503)">
                            <path d="M20.6191 8.45C19.5691 3.83 15.5391 1.75 11.9991 1.75C11.9991 1.75 11.9991 1.75 11.9891 1.75C8.45912 1.75 4.41912 3.82 3.36912 8.44C2.19912 13.6 5.35912 17.97 8.21912 20.72C9.27912 21.74 10.6391 22.25 11.9991 22.25C13.3591 22.25 14.7191 21.74 15.7691 20.72C18.6291 17.97 21.7891 13.61 20.6191 8.45ZM11.9991 13.46C10.2591 13.46 8.84912 12.05 8.84912 10.31C8.84912 8.57 10.2591 7.16 11.9991 7.16C13.7391 7.16 15.1491 8.57 15.1491 10.31C15.1491 12.05 13.7391 13.46 11.9991 13.46Z" fill="#E7EFF1"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_3013_47503">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span>${station.name}</span>
                `;
                contentWrapper.appendChild(nameContainer);
                
                const infoContainer = document.createElement('div');
                infoContainer.className = 'zigzag-sticky-image-website__station-info';
                
                if (station.address) {
                    const addressItem = document.createElement('div');
                    addressItem.className = 'zigzag-sticky-image-website__station-info-item';
                    addressItem.textContent = station.address;
                    infoContainer.appendChild(addressItem);
                }
                
                if (station.phone_numbers) {
                    const phoneItem = document.createElement('div');
                    phoneItem.className = 'zigzag-sticky-image-website__station-info-item';
                    phoneItem.textContent = station.phone_numbers;
                    infoContainer.appendChild(phoneItem);
                }
                
                contentWrapper.appendChild(infoContainer);
                card.appendChild(contentWrapper);
                
                // Get coordinates from station (can be directly lat/lng or in location string)
                const lat = station.coords.lat;
                const lng = station.coords.lng;
                
                if (lat && lng) {
                    const button = document.createElement('a');
                    button.className = 'button --new-textlink --light';
                    button.href = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
                    button.target = '_blank';
                    button.rel = 'noopener noreferrer';
                    button.innerHTML = "como llegar";
                    card.appendChild(button);
                }
                
                return card;
            };

            // Event listeners
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                isExpanded ? closeDropdown() : openDropdown();
            });

            document.addEventListener('click', (e) => {
                if (!dropdown.contains(e.target)) {
                    closeDropdown();
                }
            });

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    closeDropdown();
                }
            });
        }
    };
    
    // Steps Website Animation
    const StepsWebsite = {
        init() {
            const stepsSection = document.querySelector('.steps-website');
            if (!stepsSection) return;

            const stepItems = stepsSection.querySelectorAll('.step-item');
            if (stepItems.length === 0) return;

            // Check if screen is wider than 968px
            const isDesktop = () => window.innerWidth > 968;

            // If mobile, add classes immediately
            if (!isDesktop()) {
                stepItems.forEach(item => {
                    item.classList.add('started', 'active');
                });
                return;
            }

            let animationTriggered = false;

            const triggerAnimation = () => {
                if (animationTriggered) return;
                animationTriggered = true;

                stepItems.forEach((item, index) => {
                    // Add 'started' class after delay
                    setTimeout(() => {
                        item.classList.add('started');
                    }, index * 600);

                    // Add 'active' class 200ms after 'started'
                    setTimeout(() => {
                        item.classList.add('active');
                    }, (index * 600) + 200);
                });
            };

            // Trigger animation on hover (only on desktop)
            stepsSection.addEventListener('mouseenter', triggerAnimation);

            // Re-check on resize
            window.addEventListener('resize', () => {
                if (!isDesktop() && !animationTriggered) {
                    stepItems.forEach(item => {
                        item.classList.add('started', 'active');
                    });
                }
            });
        }
    };

    // Initialize all components
    const initComponents = () => {
        HeroWebsite.init();
        FAQWebsite.init();
        ContactFormWebsite.init();
        StationsDropdown.init();
        StepsWebsite.init();
    };
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initComponents);
    } else {
        initComponents();
    }
})();


